import { setDisplayName } from 'recompose';
import styled from 'styled-components';
import { Sans } from './core';

export const Body01 = setDisplayName('Body01')(styled(Sans)`
  font-size: var(--font-size-sm);
  line-height: var(--line-height-01);
  font-weight: var(--font-weight-regular);
  letter-spacing: var(--letter-spacing-00);
  color: var(--gray-70);
`);

export const BodyDark01 = setDisplayName('BodyDark01')(styled(Body01)`
  color: var(--gray-100);
`);

export const DarkBody01 = setDisplayName('DarkBody01')(styled(Sans)`
  font-size: var(--font-size-sm);
  line-height: var(--line-height-01);
  font-weight: var(--font-weight-regular);
  letter-spacing: var(--letter-spacing-00);
  color: var(--black-100);
`);

export const Body02 = setDisplayName('Body02')(styled(Body01)`
  color: var(--gray-60);
`);

export const BoldBody02 = setDisplayName('BoldBody02')(styled(Body01)`
  font-weight: var(--font-weight-bold);
`);

/**
 * This is for short paragraphs with no more than four lines and is commonly
 * used in components.
 */
export const BodyShort01 = setDisplayName('BodyShort01')(styled(Sans)`
  font-size: 0.875rem;
  /* line-height: 1.125rem; */
  line-height: 1.5rem;
  font-weight: 400;
  letter-spacing: 0.16px;
`);

/**
 * This is commonly used in both the expressive and the productive type theme
 * layouts for long paragraphs with more than four lines. It is a good size for
 * comfortable, long-form reading. Use this for longer body copy in components
 * such as accordion or structured list. Always left-align this type; never
 * center it.
 */
export const BodyLong01 = setDisplayName('BodyLong01')(styled(BodyShort01)`
  line-height: 1.25rem;
`);

/**
 * This is for short paragraphs with no more than four lines and is commonly
 * used in the expressive type theme for layouts.
 */
export const BodyShort02 = setDisplayName('BodyShort02')(styled(Sans)`
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 400;
  letter-spacing: 0px;
`);

/**
 * This is commonly used in the expressive type theme layouts for long
 * paragraphs with more than four lines. The looser line height and larger size
 * makes for comfortable, long-form reading, in mediums that allow for more
 * space. This size type is rarely used for body copy in components. Always
 * left-align type; never center it.
 */
export const BodyLong02 = setDisplayName('BodyLong02')(styled(BodyShort02)`
  line-height: 1.5rem;
`);
